import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import { IPaginador } from '@infotrack/presentacion-transversales/interfacesComunes';

import IDocumentoFiltro from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/documento/IDocumentoFiltro';
import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import ModeloSalidaDevolucion from 'Infotrack@Modelos/negocioRefactor/modelos/SalidaDevolucion/ModeloSalidaDevolucion';
import IDocumentoBaseConsulta from 'Infotrack@Modelos/smartStock/documentos/entidades/documentoBaseConsulta';
import { IDocumentoFirma } from 'Infotrack@Modelos/smartStock/documentos/entidades/documentoFirma';

class SalidaDevolucionCM {
    private modeloSalidaDevolucion: ModeloSalidaDevolucion;

    constructor() {
        this.modeloSalidaDevolucion = new ModeloSalidaDevolucion();
    }

    public async editarDetalle(detalle: IDocumentoDetalle) {
        if (!this.validarDetalle(detalle)) return false;
        const respuesta = await this.modeloSalidaDevolucion.editarDetalle(detalle);
        return respuesta.data.Resultado;
    }

    public async consultarDocumentoBaseSalidaInventario(documentoBase: IDocumentoBaseConsulta) {
        const respuesta = await this.modeloSalidaDevolucion.consultarDocumentoBaseSalidaInventario(documentoBase);
        return respuesta.data.Resultado;
    }

    public async eliminarDetalle(detalle: IDocumentoDetalle) {
        const respuesta = await this.modeloSalidaDevolucion.eliminarDetalle(detalle);
        return respuesta.data.Resultado;
    }

    public async guardarDetalle(detalles: IDocumentoDetalle[]) {
        if (detalles.some((detalle) => !this.validarDetalle(detalle))) return false;
        const respuesta = await this.modeloSalidaDevolucion.guardarDetalle(detalles);
        return respuesta.data.Resultado;
    }

    public async guardarEncabezado(documento: IDocumento) {
        if (!this.validarDocumento(documento)) return { Entidades: [], Resultado: false };
        const respuesta = await this.modeloSalidaDevolucion.guardarEncabezado(documento);
        return respuesta.data;
    }

    public async editarEncabezado(documento: IDocumento) {
        if (!this.validarDocumento(documento)) return { Entidades: [], Resultado: false };
        const respuesta = await this.modeloSalidaDevolucion.editarEncabezado(documento);
        return respuesta.data;
    }

    public async anularDocumento(documentoId: string) {
        const respuesta = await this.modeloSalidaDevolucion.anularDocumento(documentoId);
        return respuesta.data.Resultado;
    }

    public consultarListaDocumentos = async (paginador: IPaginador, filtro: IDocumentoFiltro) => {
        const respuesta = await this.modeloSalidaDevolucion.consultarListaDocumentos({
            Filtro: filtro,
            Paginador: paginador,
        });
        return respuesta.data;
    };

    public async consultarDetallesDocumentoBase(idDocumento: string, idBodega: number) {
        const respuesta = await this.modeloSalidaDevolucion.consultarDetallesDocumentoBase(idDocumento, idBodega);
        return respuesta.data.Entidades;
    }

    public async consultarDetallesDocumento(filtro: Partial<IDocumentoDetalle>) {
        const respuesta = await this.modeloSalidaDevolucion.consultarDetallesDocumento(filtro);
        return respuesta.data.Entidades;
    }

    public async consultarEncabezadoDocumento(filtro: Partial<IDocumento>) {
        const respuesta = await this.modeloSalidaDevolucion.consultarEncabezadoDocumento(filtro);
        return respuesta.data.Entidades[0];
    }

    public async consultarEtapas(documentoId: string) {
        const respuesta = await this.modeloSalidaDevolucion.consultarEtapas(documentoId);
        return respuesta.data.Entidades;
    }

    public async cambiarEtapa(documento: IDocumento,idUsuario:string) {
        const respuesta = await this.modeloSalidaDevolucion.cambiarEtapa(documento,idUsuario);
        return respuesta.data.Resultado;
    }

    public async consultarDocumentoBase(documentoBase: IDocumentoBaseConsulta) {
        const respuesta = await this.modeloSalidaDevolucion.consultarDocumentoBaseSalidaInventario(documentoBase);
        return respuesta.data.Entidades[0];
    }

    public async generarArchivoPDF(documentoId: string, idAplicacion: string) {
        const respuesta = await this.modeloSalidaDevolucion.generarArchivoPDF(documentoId, idAplicacion);
        return respuesta.data.Entidades[0] ;
    }
    public async guardarDocumentoFirma(documentoFirma: IDocumentoFirma) {
        const respuesta = await this.modeloSalidaDevolucion.guardarDocumentoFirma(documentoFirma);
        return respuesta.data.Entidades[0] ;
    }
  
  

    private validarDocumento(documento: IDocumento) {
        if (!documento.TipoDocumentoId) {
            notificacionGlobal('SalidaDevolucion.ValidacionNoTipoDocumentoId', 3000, 'warning', true);
            return false;
        }
        if (!documento.ProveedorId) {
            notificacionGlobal('SalidaDevolucion.ValidacionNoProveedorId', 3000, 'warning', true);
            return false;
        }
        if (!documento.BodegaOrigen) {
            notificacionGlobal('SalidaDevolucion.ValidacionNoBodegaOrigen', 3000, 'warning', true);
            return false;
        }
        return true;
    }

    private validarDetalle(detalle: IDocumentoDetalle) {
        if (!detalle.DivisionOrigen) {
            notificacionGlobal('ModalRecepcion.ValidacionNoDivisionOrigen', 3000, 'warning', true);
            return false;
        }

        if (detalle.CantidadEntregada! > detalle.CantidadRecibida!) {
            notificacionGlobal('TablaDetallesPlantilla.ValidacionCantidadMayorASolicitada', 3000, 'warning', true);
            return false;
        }
        return true;
    }
}

export default SalidaDevolucionCM;
